var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-box"},[_c('div',{staticClass:"message-content"},[_c('img',{staticClass:"close",attrs:{"src":_vm.closeBtnGrayPic},on:{"click":_vm.close}}),_c('div',{staticClass:"content"},[_vm._t("context")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }